import { Navigate, Route, Routes } from 'react-router-dom';
import { Transaction } from './Transaction';
import { Transactions } from './Transactions';
import { Visualizer } from './Visualizer';


export const TransactionsRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<Transactions />} />
      <Route path=":encRef" element={<Transaction />} />
      <Route path="visualizer" element={<Visualizer />} />
      <Route path="*" element={<Navigate to="." />} />
    </Routes>
  );
};
